interface IState {
    lightTheme: boolean
}

const initialState: IState = {
    lightTheme: true,
}

export const SET_THEME_STYLE = 'SET_THEME_STYLE'

export default function ThemeSetting(
    state: IState = initialState,
    action: { type: string; payload: boolean },
): IState {
    switch (action.type) {
        case SET_THEME_STYLE:
            return {
                lightTheme: action.payload,
            }
        default:
            return state
    }
}
